import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatToolbarModule} from '@angular/material';

import {FuseSharedModule} from '@fuse/shared.module';
import {W3Module} from '@rapi/w3/w3.module';

import {SessionService} from './services/session.service';
import {RepresentativeService} from './services/representative.service';

import {RepresentativeVoteHashDialogComponent} from '../main/slide/presentation/components/representative-vote-hash-dialog/representative-vote-hash-dialog.component';
import {SessaoHeaderComponent} from './components/sessao-header/sessao-header.component';
import {BtnToggleSidebarComponent} from './components/btn-toggle-sidebar/btn-toggle-sidebar.component';
import {VoteHashDialogComponent} from './components/vote-hash-dialog/vote-hash-dialog.component';
import { MimeTypePipe } from './mime-type.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';


@NgModule({
    imports: [
        CommonModule,
        FuseSharedModule,
        W3Module,

        // Material

        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatToolbarModule

    ],
    exports: [
        CommonModule,
        FuseSharedModule,
        W3Module,

        // Material

        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        SessaoHeaderComponent,
        BtnToggleSidebarComponent,

        MimeTypePipe,
        SafeHtmlPipe
    ],
    declarations: [
        SessaoHeaderComponent,
        BtnToggleSidebarComponent,
        MimeTypePipe,
        SafeHtmlPipe,
        VoteHashDialogComponent,
        RepresentativeVoteHashDialogComponent
    ],
    entryComponents: [
        SessaoHeaderComponent,
        BtnToggleSidebarComponent,
        VoteHashDialogComponent,
        RepresentativeVoteHashDialogComponent
    ],
    providers: [
        SessionService,
        RepresentativeService
    ]
})
export class SharedModule {
}
